var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapHandler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "4px",
    viewBox: "0 0 31 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Handle",
    fill: "#1E2B46",
    x: 0,
    y: 0,
    width: 31,
    height: 4,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapHandler);
export default __webpack_public_path__ + "static/media/map-handler.0ea261f1f044efc9420ce839aeb3cb27.svg";
export { ForwardRef as ReactComponent };